/** Memory slide variant — polaroid with masking-tape strip +
 *  warm-radial backdrop. */
import { resolveAssetUrl } from '@/lib/assetUrl';
import type { VariantProps } from '../registry';

export function MemoryVariant({ slide }: VariantProps) {
  const imageUrl = slide.imageUrl ? resolveAssetUrl(slide.imageUrl) : '';
  return (
    <>
      <div className="preview-polaroid-backdrop" aria-hidden />
      <div className="preview-slide-content relative z-10 flex flex-col items-center">
        <div className="preview-polaroid">
          <div className="preview-polaroid-tape" aria-hidden />
          {imageUrl ? (
            <img src={imageUrl} alt="" className="preview-polaroid-img" />
          ) : (
            <div className="preview-polaroid-img flex items-center justify-center bg-zinc-200 text-zinc-400">
              <span className="text-xs">No photo</span>
            </div>
          )}
        </div>
        {slide.contentText && (
          <p className="preview-polaroid-caption">{slide.contentText}</p>
        )}
      </div>
    </>
  );
}
